import { render, staticRenderFns } from "./statisticsModal.vue?vue&type=template&id=37c79812&scoped=true&"
import script from "./statisticsModal.vue?vue&type=script&lang=js&"
export * from "./statisticsModal.vue?vue&type=script&lang=js&"
import style1 from "./statisticsModal.vue?vue&type=style&index=1&id=37c79812&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c79812",
  null
  
)

export default component.exports